import { FormattedMessage } from 'react-intl';

import { SelectPropertyDropdown } from '../select-property-dropdown';
import { messages } from './messages';

import type { TextWidget, PropertyOptions, VerticalTextAlignType, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const options: PropertyOptions<VerticalTextAlignType> = [
  {
    name: <FormattedMessage {...messages.top} />,
    key: 'start',
  },
  {
    name: <FormattedMessage {...messages.center} />,
    key: 'center',
  },
  {
    name: <FormattedMessage {...messages.bottom} />,
    key: 'end',
  },
];

const VerticalTextAlignment = (props: WidgetPropertyInput<TextWidget>) => (
  <SelectPropertyDropdown options={options} property='verticalAlign' {...props} />
);

export const VerticalTextAlignmentProperty: WidgetPropertyDefinition<TextWidget> = {
  id: 'vertical-text-alignment',
  label: <FormattedMessage {...messages.label} />,
  Component: VerticalTextAlignment,
};
